
import React from 'react';
import { ReactComponent as WorldIcon } from 'icons/world.svg';
import { ReactComponent as UsersIcon } from 'icons/users.svg';
import { ReactComponent as DashboardIcon } from 'icons/dashboard.svg';
import { ReactComponent as DocsIcon } from 'icons/docs.svg';
import { ReactComponent as FinancialIcon } from 'icons/financial.svg';
import { ReactComponent as SettingsIcon } from 'icons/settings.svg';

import i18n from 'utils/translations';

import { hasPermission } from 'utils/security';

import { PERMISSIONS } from 'constants/security';

const redirect = url => {
  window.location.href = url;
};

export const languages = [{
  label: 'EN',
  switch: () => i18n.changeLanguage('EN')
},
{
  label: 'RO',
  switch: () => i18n.changeLanguage('RO')
},
{
  label: 'DE',
  switch: () => i18n.changeLanguage('DE')
}];

export const getApps = user => (
  [{
    name: 'Translations',
    icon: <WorldIcon className="w-5 h-5" />,
    hasPermission: hasPermission(user, [PERMISSIONS.VIEW_TRANSLATION_LIST]),
    onClick: () => redirect(process.env.REACT_APP_TRANSLATIONS)
  }, {
    name: 'Users',
    icon: <UsersIcon className="w-5 h-5" />,
    hasPermission: hasPermission(user, [PERMISSIONS.VIEW_USER_LIST, PERMISSIONS.VIEW_USER_LIST]),
    onClick: () => redirect(`${process.env.REACT_APP_TEAMS}/users`)
  }, {
    name: 'Dashboard',
    icon: <DashboardIcon className="w-5 h-5" />,
    hasPermission: true,
    onClick: () => redirect(process.env.REACT_APP_PTH)
  }, {
    name: 'Data list',
    icon: <DocsIcon className="w-5 h-5" />,
    hasPermission: hasPermission(user, [PERMISSIONS.VIEW_DATA_LIST_LIST]),
    onClick: () => redirect(process.env.REACT_APP_DATA_LIST)
  }, {
    name: 'Financial',
    icon: <FinancialIcon className="w-5 h-5" />,
    hasPermission: hasPermission(user, [PERMISSIONS.VIEW_FINANCIALS_LIST]),
    onClick: () => redirect(`${process.env.REACT_APP_FINANCIAL}/discounts`)
  }, {
    name: 'Settings',
    icon: <SettingsIcon className="w-5 h-5" />,
    hasPermission: hasPermission(user, [PERMISSIONS.VIEW_TEMPLATES_LIST]),
    onClick: () => redirect(`${process.env.REACT_APP_SETTINGS}/templates`)
  }]
);
